export enum TextTriggerType {
  TIME_WINDOW_CHANGED_OPERATIONAL_CONTACTS = "TIME_WINDOW_CHANGED_OPERATIONAL_CONTACTS",
  REMINDER_SMS_DAY_BEFORE = "REMINDER_SMS_DAY_BEFORE",
  REMINDER_SMS_DAY_BEFORE_OPERATIONAL_CONTACTS = "REMINDER_SMS_DAY_BEFORE_OPERATIONAL_CONTACTS",
  REMINDER_SMS_SAME_DAY = "REMINDER_SMS_SAME_DAY",
  COURIER_CANCEL_ABORT = "COURIER_CANCEL_ABORT",
  COURIER_CANCEL_ABORT_OPERATION = "COURIER_CANCEL_ABORT_OPERATION",
  COURIER_CANCEL_ABORT_RECIPIENT = "COURIER_CANCEL_ABORT_RECIPIENT",
  COURIER_CANCEL_ABORT_OPERATIONAL_CONTACTS = "COURIER_CANCEL_ABORT_OPERATIONAL_CONTACTS",
  COURIER_CANCEL_ABORT_DROPOFF_RECIPIENT = "COURIER_CANCEL_ABORT_DROPOFF_RECIPIENT",
  COURIER_ABORT_OPERATION_RECIPIENT = "COURIER_ABORT_OPERATION_RECIPIENT",
  COURIER_CANCEL_CANCEL = "COURIER_CANCEL_CANCEL",
  COURIER_DEPARTED_PICKUP_RECIPIENT = "COURIER_DEPARTED_PICKUP_RECIPIENT",
  COURIER_DEPARTED_PICKUP_ISSUER = "COURIER_DEPARTED_PICKUP_ISSUER",
  COURIER_ASSIGNED_RECIPIENT = "COURIER_ASSIGNED_RECIPIENT",
  COURIER_ASSIGNED_OPERATION_RECIPIENT = "COURIER_ASSIGNED_OPERATION_RECIPIENT",
  COURIER_HEADING_DROPOFF_ISSUER = "COURIER_HEADING_DROPOFF_ISSUER",
  COURIER_HEADING_OPERATION_ISSUER = "COURIER_HEADING_OPERATION_ISSUER",
  COURIER_HEADING_DROPOFF_RECIPIENT = "COURIER_HEADING_DROPOFF_RECIPIENT",
  COURIER_HEADING_OPERATION_RECIPIENT = "COURIER_HEADING_OPERATION_RECIPIENT",
  COURIER_HEADING_PICKUP_SENDER = "COURIER_HEADING_PICKUP_SENDER",
  SENDER_CANCEL_HEADING = "SENDER_CANCEL_HEADING",
  SENDER_CANCEL_OPERATION_HEADING = "SENDER_CANCEL_OPERATION_HEADING",
  SMS_AGENTCREATEDBYADMIN = "SMS_AGENTCREATEDBYADMIN",
  SMS_AGENT_START_ROUTE_REMINDER = "SMS_AGENT_START_ROUTE_REMINDER",
  SMS_AGENT_CLOCKED_OUT = "SMS_AGENT_CLOCKED_OUT",
  SMS_REQUIREMENT_REJECTED = "SMS_REQUIREMENT_REJECTED",
  SURVEY_RECIPIENT = "SURVEY_RECIPIENT",
  SURVEY_OPERATION_RECIPIENT = "SURVEY_OPERATION_RECIPIENT",
  USER_CANCEL_BY_ADMIN = "USER_CANCEL_BY_ADMIN",
  USER_CANCEL_OPERATION_BY_ADMIN = "USER_CANCEL_OPERATION_BY_ADMIN",
  ISSUER_CONTACT_NOT_AVAILABLE = "ISSUER_CONTACT_NOT_AVAILABLE",
  RECIPIENT_CONTACT_NOT_AVAILABLE = "RECIPIENT_CONTACT_NOT_AVAILABLE",
  ISSUER_OPERATION_CONTACT_NOT_AVAILABLE = "ISSUER_OPERATION_CONTACT_NOT_AVAILABLE",
  RECIPIENT_OPERATION_CONTACT_NOT_AVAILABLE = "RECIPIENT_OPERATION_CONTACT_NOT_AVAILABLE",
  MANUAL_ASSIGNED_SENDER = "MANUAL_ASSIGNED_SENDER",
  MANUAL_ASSIGNED_OPERATION_SENDER = "MANUAL_ASSIGNED_OPERATION_SENDER",
  OFFER_AUCTION_ASSIGNED_SENDER = "OFFER_AUCTION_ASSIGNED_SENDER",
  OFFER_AUCTION_ASSIGNED_OPERATION_SENDER = "OFFER_AUCTION_ASSIGNED_OPERATION_SENDER",
  FULFILLMENT_COMPLETED_SENDER = "FULFILLMENT_COMPLETED_SENDER",
  GENERAL_STOPSMS_MESSAGE_SUFFIX = "GENERAL_STOPSMS_MESSAGE_SUFFIX",
  SELF_PICKUP_CREATED = "SELF_PICKUP_CREATED",
  SELF_PICKUP_READY = "SELF_PICKUP_READY",
  SERVICE_CREATED = "SERVICE_CREATED",
  FIELD_SERVICE_CREATED = "FIELD_SERVICE_CREATED",
  SERVICE_CREATED_ISSUER = "SERVICE_CREATED_ISSUER",
  FIELD_SERVICE_CREATED_ISSUER = "FIELD_SERVICE_CREATED_ISSUER",
  SERVICE_EDITED = "SERVICE_EDITED",
  FIELD_SERVICE_EDITED = "FIELD_SERVICE_EDITED",
  SERVICE_COMPLETED_ISSUER = "SERVICE_COMPLETED_ISSUER",
  FIELD_SERVICE_COMPLETED_ISSUER = "FIELD_SERVICE_COMPLETED_ISSUER",
  END_OF_DROPOFF_TIME_WINDOW = "END_OF_DROPOFF_TIME_WINDOW",
  END_OF_OPERATION_TIME_WINDOW = "END_OF_OPERATION_TIME_WINDOW",
  ORDER_CREATED_RECIPIENT = "ORDER_CREATED_RECIPIENT",
  FULFILLMENT_COMPLETED_RECIPIENT = "FULFILLMENT_COMPLETED_RECIPIENT",
  ORDER_CREATED_ISSUER = "ORDER_CREATED_ISSUER",
  ORDER_COMPLETED_ISSUER = "ORDER_COMPLETED_ISSUER",
  FULFILLMENT_COMPLETED_ISSUER = "FULFILLMENT_COMPLETED_ISSUER",
  INVOICE_CREATED_ISSUER = "INVOICE_CREATED_ISSUER",
  CONSOLIDATED_INVOICE_CREATED_ISSUER = "CONSOLIDATED_INVOICE_CREATED_ISSUER",
  INVOICE_DELETED_ISSUER = "INVOICE_DELETED_ISSUER",
  DELIVERY_SCHEDULING_CREATED_RECIPIENT = "DELIVERY_SCHEDULING_CREATED_RECIPIENT",
  TASK_RETURN_TO_DEPOT = "TASK_RETURN_TO_DEPOT",
  TASK_RETURN_TO_DEPOT_RETRIP = "TASK_RETURN_TO_DEPOT_RETRIP",
  REMINDER_SMS_MINUTES_AFTER = "REMINDER_SMS_MINUTES_AFTER",
  REMINDER_SMS_MINUTES_AFTER_OPERATIONAL_CONTACTS = "REMINDER_SMS_MINUTES_AFTER_OPERATIONAL_CONTACTS",
  VISIT_SUMMARY_PDF_READY = "VISIT_SUMMARY_PDF_READY"
}
